export const deClientPortalValuationComparables = {
    emptyStateTitle: 'Für diesen Abschnitt liegen keine Daten vor.',
    marketAreaDefinitions: {
        rentableArea: 'Preis pro m² vermietbare Fläche',
        grossFloorArea: 'Preis pro m² Bruttogrundfläche',
        landArea: 'Preis pro m² Grundstücksfläche',
    },
    marketAreaReferenceUnits: {
        rentableArea: '€/m² WNFl.',
        grossFloorArea: '€/m² BGF',
        landArea: '€/m² Grundstücksfläche',
    },
    autoConvertedFootNote: 'Automatisch berechnet aus {{footNote}}',
}
